export type ThemeProviderType = {
	theme?: ThemesEnum;
};

export enum ThemesEnum {
	light = 'light',
	dark = 'dark',
}

export type ThemeColors = {
	100: string;
	200: string;
	300: string;
	400: string;
	500: string;
	600: string;
	700: string;
	800: string;
	900: string;
};

const THEME_LIGHT: ThemeColors = {
	'100': '#FFFFFF',
	'200': '#F8F8F8',
	'300': '#E0E0E0',
	'400': '#BDBDBD',
	'500': '#828282',
	'600': '#4F4F4F',
	'700': '#333333',
	'800': '#222222',
	'900': '#111111',
};

const THEME_DARK: ThemeColors = {
	'100': '#111111',
	'200': '#222222',
	'300': '#333333',
	'400': '#4F4F4F',
	'500': '#828282',
	'600': '#BDBDBD',
	'700': '#E0E0E0',
	'800': '#F8F8F8',
	'900': '#FFFFFF',
};

export const THEMES = {
	light: THEME_LIGHT,
	dark: THEME_DARK,
};

export const DEFAULT_THEME = ThemesEnum.light;
